import { render, staticRenderFns } from "./TodayCard.vue?vue&type=template&id=0a31d9fc&scoped=true&"
import script from "./TodayCard.vue?vue&type=script&lang=ts&"
export * from "./TodayCard.vue?vue&type=script&lang=ts&"
import style0 from "./TodayCard.vue?vue&type=style&index=0&id=0a31d9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a31d9fc",
  null
  
)

export default component.exports